import { ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import LinearProgress from '../../component/linearProgress/LinearProgress';
import {
  TOTAL_SERIES,
  itemEquipmentBreakdown,
  itemEquipmentBreakdownFetching,
  itemUtilizationHistory,
  itemUtilizationHistoryFetching,
} from '../../redux/slices/tools/toolsSlice';
import { useDispatch } from '../../redux/store';
import { BreakdownSummary } from './BreakdownSummary';

// Tools > Manufacturers: the dashboard's Manufacturers view on its own page,
// across every product category.
export const ToolsManufacturers = (): ReactElement => {
  const dispatch = useDispatch();
  const breakdownFetching = useSelector(itemEquipmentBreakdownFetching);
  const historyFetching = useSelector(itemUtilizationHistoryFetching);

  useEffect(() => {
    dispatch(itemEquipmentBreakdown());
    dispatch(itemUtilizationHistory());
  }, [dispatch]);

  const fetching = breakdownFetching || historyFetching;

  return (
    <>
      {fetching && <LinearProgress />}
      <BreakdownSummary category={TOTAL_SERIES} only="manufacturers" manufacturerFetching={fetching} productFetching={fetching} />
    </>
  );
};
